import React, { useEffect, useState, useRef, Component } from 'react';
//logos
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';

import { useLocation, useParams, useNavigate, useSearchParams  } from "react-router-dom";

import '../assets/style/smart-report.css';

import PatientInfo from '../components/patientInfo';
import Benefits from '../components/benefits';
import TableOfContent from '../components/tableOfContent';
import SneakPeak from '../components/sneakpeak';
import ReportSummary from '../components/reportsummary';
import Disclaimer from '../components/disclaimer';
import References from '../components/references';
import { ImmediateTests } from '../components/recommendedTest';
import { DietRecommendarions, LifeStyleRecommendations, Recommendations } from '../components/recommendedDietLifestyle';
import CriticalParemeters from '../components/criticalParameters';
import ReportDetailsList from '../components/reportDetailsList';
import TrustInfo from '../components/trust';
// QR Code
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';

// import api for data fetch using labnumber from url
import fetchSmartReportData from '../services/apiServices';
import Preloader from '../components/preloading';

function encodeBase64(data) {
    return btoa(data); // Encoding lab number and last name in base64 format
}
function decodeBase64(encodedData) {
    return decodeURIComponent(escape(atob(encodedData))); // Decode and handle special characters
}

function SmartReport() {

    const contentRef = useRef();
   
    const [data, setReportData] = useState(null);
    const { search, state } = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(search);

    const [lno, setLno] = useState(() => {
        const labNumberFromStorage = state?.labNumber;
        const labNumberFromBrowserURL = queryParams.get('lno');
        if (labNumberFromBrowserURL) {
            return queryParams.get('lno');           
        } else if(labNumberFromStorage) {
            return decodeBase64(labNumberFromStorage); 
        }
        return null;
    })
    const [lastName, setlastName] = useState(() => {
        const lastNameFromStorage = state?.lastName;;
        const lastNameFromBrowserURL = queryParams.get('lastName');
        if (lastNameFromBrowserURL){
            return encodeBase64(lastNameFromBrowserURL);
        } else if (lastNameFromStorage){
            return lastNameFromStorage;
        }
        return '';
    })
    
    
     // 🔁 Redirect if lab number is missing
     useEffect(() => {
        if (!lno) {
            navigate('/', { replace: true }); // Replace true to avoid back navigation
        }
    }, [lno, navigate]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchedData = await fetchSmartReportData(lno, lastName || '');
                if (!fetchedData || !fetchedData.data) {
                    if (fetchedData && fetchedData.message === "No record found!") {
                        setReportData({ message: "No record found!" })
                    } else {
                        setReportData(null);
                    }

                } else {
                    setReportData(fetchedData);
                }
                // setReportData(fetchedData);

            } catch (error) {
               // console.log('Error fetching data:', error);
                setReportData(null);
            }
        };
        if (lno) {
            fetchData();
        }
    }, [lno, lastName]);


    if (!data) {
        return (
            <>
                <Preloader />
            </>
        );
    } 
    else if (data.message === "No record found!") {
        return (
            <>
                {/* <div>{data.message}</div> */}
                <PatientInfo data={data} />
            </>
        )
    }
   
    //labNumber use for generate qr
    const apiLabNumber = data?.data?.patientDetails.LabNumber;
    const uriLno = encodeURIComponent(lno);
    const encodedLno = btoa(uriLno);
    // const qrurl = `https://smartreport.lalpathlabs.com/report/?lno=${(lno)}`
    //const qrurl = `http://localhost:3001/verify-lastname/?lno=${encodeBase64(lno)}`
  //  const qrurl = `https://smartreport.lalpathlabs.com/verify-lastname/?lno=${lno}`
    const qrurl = `https://smartreport.lalpathlabs.com/verify-lastname?lno=${apiLabNumber}`;
   // console.log(qrurl)

   // for getting country code
    const patientInfo = data?.data?.patientDetails || {};
    const getCountry = () => {
        const Company = (patientInfo.Company || '').toUpperCase();
        if (Company === 'BANG') {
            return 'BANGLADESH';
        } else if (Company === 'NEP') {
            return 'NEPAL';
        } else {
            return 'BHARAT';
        }
    };
    const country = getCountry();

    
    const captureScreenshot = (section) => {
        return new Promise((resolve, reject) => {
            // Save the original width and height of the section before modifying them
            const originalWidth = section.style.width;
            const originalHeight = section.style.height;
    
            // Get the container and container-1 elements
            const container = section.querySelector('.container');
            const container1 = section.querySelector('.container-1');
    
            // Apply fixed width and height for screenshot capture without affecting the layout
            section.style.width = '1100px';
            section.style.height = '1560px';
            // section.style.width = '1050px';
            // section.style.height = '1489px';
            // Use html2canvas to capture the screenshot
            html2canvas(section, {
                scale: 1, // Reduce resolution if needed
                logging: false, // Disable logging to speed up capture
                useCORS: true, // Enable CORS if needed
            }).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');  // Capture the section as base64 image
                if (imgData) {
                    resolve(imgData);  // Return base64 image data
                } else {
                    reject('Failed to capture image data');
                }
    
                // Restore original width and height of the section
                section.style.width = originalWidth;
                section.style.height = originalHeight;
    
            }).catch((error) => {
                // Restore original width and height in case of error
                section.style.width = originalWidth;
                section.style.height = originalHeight;
                reject(error);
            });
        });
    };
    
    const handlePrint = async () => {
        const screenshots = [];
        const sections = contentRef.current.querySelectorAll('.section');  // Get all section elements
    
        if (sections.length === 0) {
            console.error('No sections found for screenshot capture.');
            return;
        }
    
        try {
            // Capture all screenshots in parallel
            const capturePromises = Array.from(sections).map((section) => captureScreenshot(section));
    
            // Wait for all screenshots to be captured
            const capturedScreenshots = await Promise.all(capturePromises);
    
            // Add the captured screenshots to the array
            screenshots.push(...capturedScreenshots);
    
            // Log the screenshots data before sending
            // console.log('Sending to server:', {
            //     apiLabNumber,
            //     screenshots
            // });
    
            // Send the screenshots to the server to generate the PDF
            const response = await fetch('http://localhost:5000/generate-pdf', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Frame-Options':'DENY'
                },
                body: JSON.stringify({
                    labNumber: apiLabNumber,
                    screenshots: screenshots,  // Send screenshots as base64 image data
                }),
            });
    
            if (!response.ok) {
                console.error('Error generating PDF:', response.statusText);
            } else {
                const pdfBlob = await response.blob();
                const pdfUrl = URL.createObjectURL(pdfBlob);
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.download = `smart-report-${apiLabNumber}.pdf`;
                link.click();  // Trigger the download
                URL.revokeObjectURL(pdfUrl);
            }
        } catch (error) {
            console.error('Error capturing screenshots or sending request to server:', error);
        }
    };
    
    return (
        <>
            <div className='container-top' ref={contentRef}>

                {/* page 1 */}
                <PatientInfo data={data} />
                {/* Page 2 */}
                <Benefits />
                {/* page3 */}
                {/* <!--table of content--> */}
                <section className="section section-2" id="tableContent">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <TableOfContent />

                        </div>
                    </div>
                </section>
                {/* <!-- end table of content--> */}

                {/* page 4 */}
                <section className="section section-3" id="report-overview">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <SneakPeak data={data} />
                        </div>
                        <div className="row">
                            <div className="container-1">
                                <div className="col-12">
                                    <ul className="indicator">
                                        <li className="normal">Within Normal Limit</li>
                                        {/* <li className="borderline">Borderline</li> */}
                                        <li className="abnormal">Need attention</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="container-1">
                                <div className="col-12 mt-0">
                                    <a target='_blank' href={`https://www.lalpathlabs.com/swasth-fit-packages-full-body-checkups`}>Click here</a> to read more about your vital parameters through our blogs.
                                </div>
                                <div className="col-12 mt-3">
                                    {apiLabNumber && (
                                        <QRCodeCanvas value={qrurl} size={120} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* page 5 */}
                {/* <!--Summary page--> */}

                <ReportSummary data={data} />

                {/* <!--end  Summary page--> */}

                {/* crital parameters */}

                <CriticalParemeters data={data} />

                {/* page 8 */}

                <ReportDetailsList data={data} />

                {/* page 12 */}
                {/* <section className="section section-5" id="diet-recomendation">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="container-1 benefits">
                                <DietRecommendarions data={data} />
                                <LifeStyleRecommendations data={data} />
                            </div>
                        </div>
                    </div>
                </section> */}

                <Recommendations data={data}/>


                {/* page 13 */}

                <ImmediateTests data={data} />
                


                {/* page 14 */}
                <section className="section section-7 " id="references">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="container-1 benefits">

                                <References />
                                <Disclaimer />
                            </div>
                        </div>
                    </div>
                </section>

                {/* page15 */}
                 {country === 'BHARAT' && (
                    <section className="section section-8 " style={{ backgroundColor: '#fffaf4' }}>
                        <TrustInfo data={data} />
                    </section>
                )}

                <div className='text-center generate-pdf-wrapper d-none mt-3 mb-3'>
                    <button className='btn btn-primary' onClick={handlePrint}>Generate PDF</button>
                </div>

            </div>
        </>
    );

}

export default SmartReport;